import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-206046b6"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "tableHeader"
};
var _hoisted_2 = { key: 0 };
var _hoisted_3 = {
    key: 1,
    class: "searchBar"
};
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "horizontalLine" }, null, -1); });
var _hoisted_5 = {
    key: 2,
    class: "scrollable"
};
var _hoisted_6 = {
    key: 0,
    style: { "margin-left": "45%" }
};
var _hoisted_7 = { key: 3 };
var _hoisted_8 = {
    key: 0,
    class: "links"
};
var _hoisted_9 = ["href"];
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1); });
var _hoisted_11 = ["href"];
import CollapsibleRow from "@/layout/collapsible/CollapsibleRow.vue";
import actionButton from "@/components/actionButton.vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import SearchBar from "@/components/SearchBar.vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollapsibleContainer',
    props: {
        data: Object,
        textData: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["rowActions", "create-form", "search"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var router = useRouter();
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        function createForm() {
            emit("create-form");
        }
        function rowAction(item, row, index) {
            emit("rowActions", item, row, index);
        }
        function doSearch(ev) {
            var searchword = ev.toLowerCase();
            var emptycheck = ev.replace(/\s/g, "");
            emit('search', searchword, emptycheck.length > 0);
        }
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
            var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
            return (_openBlock(), _createElementBlock("div", null, [
                ((((_a = props.data) === null || _a === void 0 ? void 0 : _a.layoutType) === 'FormEdit' || ((_b = props.data) === null || _b === void 0 ? void 0 : _b.layoutType) == null) &&
                    ((_c = props.data) === null || _c === void 0 ? void 0 : _c.subtitle) != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (((_d = props.data) === null || _d === void 0 ? void 0 : _d.subtitle) !== '')
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString((_e = props.data) === null || _e === void 0 ? void 0 : _e.subtitle), 1))
                            : _createCommentVNode("", true),
                        (((_f = props.data) === null || _f === void 0 ? void 0 : _f.headerIcon) == 'plus' && _unref(patient)[(_g = props.data) === null || _g === void 0 ? void 0 : _g.data] != null)
                            ? (_openBlock(), _createBlock(actionButton, {
                                key: 1,
                                id: "Adder",
                                iconname: (_h = props.data) === null || _h === void 0 ? void 0 : _h.headerIcon,
                                style: { "font-size": "35px", "margin-right": "20px", "cursor": "pointer" },
                                colorbackground: "#11A696",
                                onCallAction: _cache[0] || (_cache[0] = function ($event) { return (createForm()); })
                            }, null, 8, ["iconname"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (((_j = props.data) === null || _j === void 0 ? void 0 : _j.headerIcon) === 'search')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(SearchBar, {
                            readonly: _unref(patient)[(_k = props.data) === null || _k === void 0 ? void 0 : _k.data] == null,
                            onCapture: _cache[1] || (_cache[1] = function ($event) { return (doSearch($event)); })
                        }, null, 8, ["readonly"])
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_4,
                (((_l = props.data) === null || _l === void 0 ? void 0 : _l.layoutType) === 'FormEdit' || ((_m = props.data) === null || _m === void 0 ? void 0 : _m.layoutType) == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (((_p = _unref(patient)[(_o = props.data) === null || _o === void 0 ? void 0 : _o.data]) === null || _p === void 0 ? void 0 : _p.length) == 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("noData")), 1))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).patient[(_q = props.data) === null || _q === void 0 ? void 0 : _q.data], function (item, index) {
                            return (_openBlock(), _createBlock(CollapsibleRow, {
                                key: index,
                                row: item,
                                data: __props.data,
                                onRowActions: function (n, r) { return rowAction(n, r, index); }
                            }, null, 8, ["row", "data", "onRowActions"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                ((_r = props.data) === null || _r === void 0 ? void 0 : _r.textOrRow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (((_s = props.data) === null || _s === void 0 ? void 0 : _s.title) === 'Link utili')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("a", {
                                    href: (_t = props.data) === null || _t === void 0 ? void 0 : _t.link1,
                                    target: "_blank",
                                    class: "link"
                                }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrow-up-right-from-square'] }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Calendario Vaccinale")), 1)
                                ], 8, _hoisted_9),
                                _hoisted_10,
                                _createElementVNode("a", {
                                    href: (_u = props.data) === null || _u === void 0 ? void 0 : _u.link2,
                                    target: "_blank",
                                    class: "link"
                                }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'arrow-up-right-from-square'] }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Vaccinazioni per chi viaggia")), 1)
                                ], 8, _hoisted_11)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
